export default "__VITE_ASSET__R6l0DzWb__"